import { requester } from "App";
import P from "components/P";
import Container from "layouts/container/Container";
import FlexChild from "layouts/flex/FlexChild";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { useEffect, useState } from "react";
import styles from "./VendorList.module.css";

function VendorList() {
    const [list, setList] = useState();
    const [loading, setLoading] = useState(true);

    // 컬럼명 한글 변환 맵핑
    const headerTranslations = {
        'id': 'ID',
        'userName': '사용자명',
        'mobileNo': '전화번호',
        'storeId': '매장 ID',
        'storeName': '매장명',
        'role': '역할',
        'cardCommissionRate': '카드 수수료율',
        'serverUsageFee': '서버 사용료',
        'licenseFee': '라이센스 비용',
        'salesCommissionType': '판매 수수료 유형',
        'salesCommissionValue': '판매 수수료 값',
        'storeCode': '매장 코드',
        'store.id': '매장 ID',
        'store.name': '매장명',
        'store.code': '매장 코드',
        'VENDOR': '점주',
        'FIXED_AMOUNT': '고정 금액',
        'PERCENTAGE': '퍼센트'
    };

    // 컬럼명 한글 변환 함수
    const translateHeader = (header) => {
        return headerTranslations[header] || header;
    };

    // 셀 데이터 변환 함수
    const formatCellValue = (value) => {
        // 특정 값에 대한 매핑 처리
        if (value === 'VENDOR') return '점주';
        if (value === 'FIXED_AMOUNT') return '고정 금액';
        if (value === 'PERCENTAGE') return '퍼센트';
        
        return value;
    };

    // 중첩된 객체 포함 모든 키를 추출하는 함수
    const extractHeaders = (data) => {
        const headersSet = new Set();
        data &&
            data.forEach(item => {
                Object.keys(item).forEach(key => {
                    if (key !== 'password') { // 'password' 키는 제외
                        if (typeof item[key] === 'object' && item[key] !== null) {
                            Object.keys(item[key]).forEach(subKey => {
                                headersSet.add(`${key}.${subKey}`);
                            });
                        } else {
                            headersSet.add(key);
                        }
                    }
                });
            });
        return Array.from(headersSet);
    };
    
    // 중첩된 데이터 접근 함수
    const getNestedValue = (item, path) => {
        const keys = path.split('.');
        let result = item;
        for (let key of keys) {
            if (result === undefined || result === null) return '';
            result = result[key];
        }
        return result;
    };

    useEffect(() => {
        let data = { storeId: "root" }
        setLoading(true);
        requester.findAllVendor(data, (result) => {
            setList(result.data);
            setLoading(false);
        })
    }, [])
    
    // Only compute headers when list is available
    const headers = list ? extractHeaders(list) : [];

    return (
        <div className={styles.container}>
            <div className={styles.flexGrid}>
                <div className={`${styles.flexBox} ${styles.fullWidth}`}>
                    <div className={styles.card}>
                        <div className={styles.section}>
                            <div className={styles.sectionTitle}>점주 리스트</div>
                            <div className={styles.sectionContent}>
                                {loading ? (
                                    <div className={styles.loadingContainer}>
                                        <p>데이터 로딩 중...</p>
                                    </div>
                                ) : list && list.length > 0 ? (
                                    <div className={styles.tableContainer}>
                                        <table className={styles.dataTable}>
                                            <thead>
                                                <tr>
                                                    {headers.map((header) => (
                                                        <th key={header}>{translateHeader(header)}</th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {list.map((item, index) => (
                                                    <tr key={index}>
                                                        {headers.map((header) => (
                                                            <td key={`${index}-${header}`}>
                                                                {formatCellValue(getNestedValue(item, header))}
                                                            </td>
                                                        ))}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <div className={styles.emptyMessage}>
                                        <p>점주 데이터가 없습니다.</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default VendorList;